module.exports = __webpack_public_path__ + "img/slide11_vn.cb23de21.jpg";